const templateMan = () => import("./views/templateMan.vue");

export default {
  path: "/templateMan",
  name: "templateMan",
  component: templateMan,
  meta: {
    root: "/inforMan"
  }
}



// WEBPACK FOOTER //
// ./src/core/modules/template/router.js